import { render } from "./VTaskFilter.vue?vue&type=template&id=154b6b1b&ts=true"
import script from "./VTaskFilter.vue?vue&type=script&lang=ts"
export * from "./VTaskFilter.vue?vue&type=script&lang=ts"

import "./VTaskFilter.vue?vue&type=style&index=0&id=154b6b1b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__